// extracted by mini-css-extract-plugin
export default {"loader":"Style_loader__WdrKr","full":"Style_full__2eGAB","circleBorder":"Style_circleBorder__445xf","spin":"Style_spin__lnQun"};